/* SPOOKY CART — local-storage wishlist */
(function () {
  'use strict';
  const KEY = 'spooky:wishlist';
  const S = window.Spooky || (window.Spooky = {});

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  };

  function count() { return read().length; }

  function syncBadges() {
    const n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  function syncButtons(root) {
    const list = read();
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-wishlist-toggle');
      btn.setAttribute('aria-pressed', String(list.includes(id)));
    });
  }

  function toggle(id) {
    const list = read();
    const i = list.indexOf(id);
    if (i === -1) list.push(id); else list.splice(i, 1);
    write(list);
    syncBadges();
    syncButtons();
    return i === -1;
  }

  S.wishlist = { read, toggle, count };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const added = toggle(btn.getAttribute('data-wishlist-toggle'));
    const label = added ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
    if (label) btn.setAttribute('aria-label', label);
  });

  document.addEventListener('DOMContentLoaded', () => { syncBadges(); syncButtons(); });
  document.addEventListener('shopify:section:load', (e) => syncButtons(e.target));
})();
